const de = {
  "nav.chefs": "Unsere Chefs",
  "nav.experiences": "Erlebnisse",
  "nav.privateDining": "Private Dining",
  "nav.journal": "Journal",
  "nav.howItWorks": "So Funktioniert's",
  "nav.events": "Events",
  "nav.corporate": "Unternehmen",
  "nav.bespoke": "Maßgeschneidert",
  "nav.giftCards": "Geschenkkarten",
  "nav.becomeChef": "Chef Werden",
  "nav.about": "Über Uns",
  "nav.contact": "Kontakt",
  "nav.faq": "FAQ",
  "nav.login": "Anmelden",
  "nav.logout": "Abmelden",
  "nav.account": "Mein Konto",
  "nav.findChef": "Meinen Chef Finden",
  "nav.more": "Mehr",
  "hero.line1": "Außergewöhnliche Küche.",
  "hero.line2": "Bei Ihnen Zuhause.",
  "hero.sub": "Verifizierte Privatköche schaffen Fünf-Sterne-Erlebnisse in der Intimität Ihres Esszimmers. In Paris und darüber hinaus.",
  "hero.badge": "Privatkoch-Concierge",
  "search.location": "Stadt",
  "search.date": "Datum",
  "search.guests": "Gäste",
  "search.cuisine": "Küche",
  "search.experience": "Erlebnis",
  "search.any": "Alle",
  "search.cta": "Meinen Chef Finden",
  "home.featuredEyebrow": "Die Auswahl des Hauses",
  "home.featuredTitle": "Chefs von Rang",
  "home.viewAll": "Alle Chefs entdecken",
  "home.expEyebrow": "Signature-Erlebnisse",
  "home.expTitle": "Sechs Arten, Außergewöhnlich zu Speisen",
  "home.trustEyebrow": "Unser Versprechen",
  "home.trustTitle": "Jeder Chef, Sorgfältig Ausgewählt",
  "home.trustIntro": "Hinter jedem «Verifizierter Chef»-Badge steht eine strenge professionelle Prüfung. Nur Köche, die unsere vollständige Überprüfung bestehen, werden zugelassen — Ihr Tisch ist stets in Expertenhänden.",
  "trust.i1": "Identitätsprüfung (KYC)",
  "trust.i2": "Prüfung der Berufserfahrung",
  "trust.i3": "Profil- & Portfolio-Prüfung",
  "trust.i4": "Prüfung der Küchenpraxis",
  "trust.i5": "Standards des Gerichte-Portfolios",
  "trust.i6": "Geltende Hygienedokumentation",
  "trust.i7": "Bank-Compliance",
  "home.manifestoEyebrow": "Das Manifest",
  "man.c1t": "Der Tisch Ist Heilig",
  "man.c1b": "Ein Abendessen zuhause ist keine Lieferung. Es ist Theater, Gastfreundschaft und Handwerk — komponiert für die Menschen, die Sie lieben, am Ort, den Sie am meisten lieben.",
  "man.c2t": "Handwerk vor Bequemlichkeit",
  "man.c2b": "Unsere Köche kaufen auf den Morgenmärkten ein, kochen in Ihrer Küche und servieren Gang für Gang. Nichts aufgewärmt, nichts gewöhnlich.",
  "man.c3t": "Vertrauen, Verifiziert",
  "man.c3b": "Jeder Chef bei Chef à Domicile besteht eine professionelle Prüfung, bevor ein einziger Teller serviert wird. Exzellenz ist die Eintrittsbedingung.",
  "home.marquee": "Privatkoch Paris — Chef à Domicile — Luxus Private Dining — Maßgeschneiderte Menüs — Fünf-Sterne-Gastfreundschaft —",
  "home.ctaTitle": "Ihr Tisch verdient einen Chef.",
  "home.ctaBtn": "Erlebnis Buchen",
  "home.journalEyebrow": "Das Journal",
  "home.journalTitle": "Geschichten vom Tisch",
  "common.verified": "Verifizierter Chef",
  "common.perGuest": "pro Gast",
  "common.from": "Ab",
  "common.viewProfile": "Profil Ansehen",
  "common.book": "Buchen",
  "common.loading": "Lädt…",
  "common.error": "Etwas ist schiefgelaufen.",
  "common.retry": "Erneut versuchen",
  "common.empty": "Noch nichts hier.",
  "common.readMore": "Weiterlesen",
  "common.back": "Zurück",
  "common.send": "Senden",
  "common.sending": "Wird gesendet…",
  "common.yearsExp": "{n} Jahre Erfahrung",
  "common.reviews": "Bewertungen",
  "common.languages": "Sprachen",
  "common.all": "Alle",
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.delete": "Löschen",
  "common.add": "Hinzufügen",
  "common.optional": "optional",
  "common.next": "Weiter",
  "common.confirm": "Bestätigen",
  "common.total": "Gesamt",
  "common.guests": "Gäste",
  "chefs.title": "Der Marktplatz Verifizierter Chefs",
  "chefs.sub": "Außergewöhnliche Privatköche, von unserem Team verifiziert, bereit, bei Ihnen zu kochen.",
  "chefs.filters": "Filter",
  "chefs.clear": "Filter löschen",
  "chefs.cuisine": "Küche",
  "chefs.city": "Stadt",
  "chefs.minRating": "Mindestbewertung",
  "chefs.maxPrice": "Max. Preis / Gast",
  "chefs.language": "Sprache des Chefs",
  "chefs.noResults": "Keine Chefs entsprechen diesen Kriterien. Erweitern Sie Ihre Suche.",
  "chefs.count": "{n} verifizierte(r) Chef(s)",
  "chef.about": "Über den Chef",
  "chef.signature": "Signature-Gerichte",
  "chef.reviews": "Gästebewertungen",
  "chef.bookThis": "Diesen Chef Buchen",
  "chef.qualification": "Qualifikation",
  "chef.allergens": "Allergene",
  "chef.dietary": "Ernährung",
  "chef.prep": "{n} Min. Zubereitung",
  "exp.title": "Signature-Erlebnisse",
  "exp.sub": "Sechs kuratierte Wege, außergewöhnliche Küche nach Hause zu bringen — vom intimen À-la-carte-Dinner bis zum maßgeschneiderten Gastro-Event.",
  "booking.title": "Reservieren Sie Ihr Erlebnis",
  "booking.step1": "Menü",
  "booking.step2": "Details",
  "booking.step3": "Bestätigen & Zahlen",
  "booking.selectDish": "Wählen Sie ein Signature-Gericht",
  "booking.date": "Datum",
  "booking.time": "Uhrzeit",
  "booking.address": "Adresse",
  "booking.city": "Stadt",
  "booking.occasion": "Anlass",
  "booking.requests": "Besondere Wünsche",
  "booking.create": "Buchung prüfen",
  "booking.promo": "Promo- oder Geschenkkartencode",
  "booking.promoApply": "Anwenden",
  "booking.promoApplied": "Code angewendet",
  "booking.chef": "Ihr Chef",
  "booking.pricePerGuest": "Preis pro Gast",
  "booking.pay": "Zur Sicheren Zahlung",
  "booking.payNote": "Sie werden zu einer sicheren Stripe-Zahlung weitergeleitet. Der Endbetrag wird von unserem Service berechnet.",
  "booking.loginFirst": "Bitte melden Sie sich an, um Ihre Buchung abzuschließen.",
  "booking.stripeOff": "Online-Zahlung ist vorübergehend nicht verfügbar. Ihre Buchung ist gespeichert — unser Concierge kontaktiert Sie zur Zahlungsabwicklung.",
  "booking.discount": "Rabatt",
  "pay.checking": "Zahlung wird bestätigt…",
  "pay.success": "Zahlung bestätigt. Ihr Chef wurde benachrichtigt — bis bald am Tisch.",
  "pay.failed": "Die Zahlung wurde nicht abgeschlossen.",
  "pay.pending": "Die Zahlung wird noch verarbeitet. Diese Seite aktualisiert sich automatisch.",
  "pay.backAccount": "Zu meinen Buchungen",
  "auth.loginTitle": "Willkommen Zurück",
  "auth.registerTitle": "Konto Erstellen",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.name": "Vollständiger Name",
  "auth.loginBtn": "Anmelden",
  "auth.registerBtn": "Konto Erstellen",
  "auth.toRegister": "Neu bei Chef à Domicile? Konto erstellen",
  "auth.toLogin": "Bereits Mitglied? Anmelden",
  "account.title": "Mein Konto",
  "account.bookings": "Buchungen",
  "account.favorites": "Favoriten",
  "account.giftcards": "Geschenkkarten",
  "account.dietary": "Ernährungsprofil",
  "account.addresses": "Adressen",
  "account.noBookings": "Noch keine Buchungen. Ihr nächstes außergewöhnliches Dinner wartet.",
  "account.noFavorites": "Noch keine Lieblingsköche.",
  "account.status": "Status",
  "account.cancelBooking": "Buchung stornieren",
  "account.review": "Bewertung abgeben",
  "account.reviewComment": "Ihr Kommentar",
  "account.messages": "Nachrichten",
  "account.writeMsg": "Schreiben Sie Ihrem Chef eine Nachricht…",
  "account.allergies": "Allergien",
  "account.diets": "Ernährung & Vorlieben",
  "account.saveProfile": "Profil speichern",
  "account.addAddress": "Adresse hinzufügen",
  "account.label": "Bezeichnung (Zuhause, Büro…)",
  "account.noGiftcards": "Noch keine Geschenkkarten-Bestellungen.",
  "account.commaHint": "Mit Kommas trennen",
  "gift.title": "Das Geschenk eines Unvergesslichen Tisches",
  "gift.sub": "Verschenken Sie ein Privatkoch-Erlebnis. Der Empfänger erhält eine elegante Geschenkkarte, einlösbar bei jeder Buchung.",
  "gift.amount": "Betrag (25 € – 1000 €)",
  "gift.recipientName": "Name des Empfängers",
  "gift.recipientEmail": "E-Mail des Empfängers",
  "gift.message": "Persönliche Nachricht",
  "gift.buy": "Geschenkkarte Kaufen",
  "gift.note": "Der Code wird erst nach bestätigter Zahlung generiert und per E-Mail versandt.",
  "becomeChef.title": "Kochen Sie für die Schönsten Tische",
  "becomeChef.sub": "Werden Sie Privatkoch bei Chef à Domicile. Ihre Menüs, Ihre Preise, Ihr Kalender — wir bringen Ihnen anspruchsvolle Kunden.",
  "becomeChef.cta": "Als Chef Bewerben",
  "becomeChef.bio": "Ihre Geschichte & kulinarischer Werdegang",
  "becomeChef.years": "Jahre Erfahrung",
  "becomeChef.qualification": "Qualifikation / Ausbildung",
  "becomeChef.city": "Stadt",
  "becomeChef.cuisines": "Ihre Küchen",
  "becomeChef.success": "Bewerbung erhalten. Ihr Profil durchläuft nun unseren professionellen Verifizierungsprozess — unser Team meldet sich bei Ihnen.",
  "becomeChef.s1t": "Bewerben",
  "becomeChef.s1b": "Erzählen Sie uns von Ihrer Erfahrung, Ausbildung und Signature-Küche.",
  "becomeChef.s2t": "Verifiziert Werden",
  "becomeChef.s2b": "Identität, Erfahrung, Küchenpraxis und Portfolio werden professionell geprüft.",
  "becomeChef.s3t": "Kochen & Verdienen",
  "becomeChef.s3b": "Erhalten Sie Buchungen anspruchsvoller Kunden und werden Sie sicher bezahlt.",
  "inquiry.contactTitle": "Kontaktieren Sie das Haus",
  "inquiry.contactSub": "Eine Frage, ein Projekt, ein besonderer Wunsch — unser Concierge antwortet innerhalb von 24 Stunden.",
  "inquiry.corporateTitle": "Firmen-Erlebnisse",
  "inquiry.corporateSub": "Executive-Dinner, Kundenbewirtung, Team-Feiern — Küche, die für Ihr Unternehmen spricht.",
  "inquiry.corporateCta": "Firmen-Erlebnis Anfragen",
  "inquiry.eventsTitle": "Events Jeder Größenordnung",
  "inquiry.eventsSub": "Geburtstage, Hochzeiten, Empfänge — eine komplette kulinarische Produktion, vom Menü bis zum Service.",
  "inquiry.eventsCta": "Mein Event Planen",
  "inquiry.bespokeTitle": "Vollständig Maßgeschneiderte Menüs",
  "inquiry.bespokeSub": "Ein einzigartiges Menü, mit Ihrem Chef entworfen — um Ihre Geschichte, Ihre Produkte, Ihren Anlass.",
  "inquiry.bespokeCta": "Maßgeschneidertes Projekt Starten",
  "inquiry.eventType": "Art des Events",
  "inquiry.budget": "Budget",
  "inquiry.location": "Ort",
  "inquiry.company": "Unternehmen",
  "inquiry.phone": "Telefon",
  "inquiry.date": "Wunschdatum",
  "inquiry.guests": "Gäste",
  "inquiry.message": "Ihre Nachricht",
  "inquiry.success": "Vielen Dank. Unser Concierge-Team meldet sich in Kürze.",
  "how.title": "So Funktioniert's",
  "how.sub": "Vom ersten Klick bis zum letzten Gang — mühelos, in vier Sätzen.",
  "how.s1t": "01 — Komponieren",
  "how.s1b": "Wählen Sie Stadt, Datum, Gäste und Küche. Entdecken Sie verifizierte Chefs und ihre Signature-Gerichte.",
  "how.s2t": "02 — Reservieren",
  "how.s2b": "Buchen Sie in Minuten. Der Preis wird transparent pro Gast berechnet — ohne versteckte Kosten.",
  "how.s3t": "03 — Empfangen Sie Ihren Chef",
  "how.s3b": "Ihr Chef kommt mit frischen Produkten, kocht in Ihrer Küche und serviert Gang für Gang.",
  "how.s4t": "04 — Einfach Genießen",
  "how.s4b": "Ihr Chef hinterlässt die Küche makellos. Ihnen bleiben die Erinnerungen — und die Komplimente.",
  "about.title": "Das Haus",
  "about.p1": "Chef à Domicile entstand aus einer einfachen Überzeugung: Das denkwürdigste Restaurant der Welt ist Ihr eigenes Zuhause. Wir verbinden anspruchsvolle Gastgeber mit verifizierten Privatköchen, die ein Esszimmer in einen Fünf-Sterne-Tisch verwandeln.",
  "about.p2": "Von Paris aus kuratiert unser Concierge-Marktplatz Köche aus 28 Weltküchen — jeder professionell geprüft: Identität, Erfahrung, Küchenpraxis und Portfolio.",
  "about.p3": "Wir sind keine Essenslieferung. Wir sind Gastfreundschaft — die Kunst des Tisches, nach Hause gebracht.",
  "privateDining.title": "Private Dining, Perfektioniert",
  "privateDining.sub": "Intime Dinner für 2 bis 20 Gäste, orchestriert von einem verifizierten Privatkoch.",
  "privateDining.p1": "Ein Abend mit Chef à Domicile beginnt lange vor dem ersten Gang. Ihr Chef entwirft das Menü mit Ihnen, wählt die besten Produkte des Morgens und verwandelt Ihre Küche in den Pass eines feinen Restaurants.",
  "privateDining.p2": "Gang für Gang wird an Ihrem Tisch serviert — während Sie bei Ihren Gästen bleiben. Am Ende des Abends ist die Küche makellos.",
  "privateDining.cta": "Einen Chef für Mein Dinner Finden",
  "faq.title": "Häufige Fragen",
  "faq.q1": "Wie werden Chefs verifiziert?",
  "faq.a1": "Jeder Chef durchläuft eine professionelle Prüfung: Identität (KYC), Berufserfahrung, Profilprüfung, Küchenpraxis, Gerichte-Portfolio, geltende Hygienedokumentation und Bank-Compliance. Nur verifizierte Chefs erscheinen auf dem Marktplatz.",
  "faq.q2": "Was ist im Preis pro Gast enthalten?",
  "faq.a2": "Einkauf, Vorbereitung, Kochen, Tischservice des Menüs und Küchenreinigung. Der Gesamtbetrag wird bei der Buchung transparent von unserem Service berechnet.",
  "faq.q3": "Können Menüs an Allergien oder Diäten angepasst werden?",
  "faq.a3": "Ja. Speichern Sie Allergien und Vorlieben in Ihrem Ernährungsprofil und fügen Sie jeder Buchung besondere Wünsche hinzu — Ihr Chef passt das Menü an.",
  "faq.q4": "Wie funktioniert die Zahlung?",
  "faq.a4": "Zahlungen werden sicher über Stripe abgewickelt. Belastet wird erst bei Bestätigung der Buchung; Geschenkkarten und Promo-Codes werden vor dem Checkout angewendet.",
  "faq.q5": "Kann ich eine Buchung stornieren?",
  "faq.a5": "Ja, über Ihr Konto. Siehe unsere Stornierungsrichtlinie für die Bedingungen je nach Vorlaufzeit.",
  "journal.title": "Das Journal",
  "journal.sub": "Gastronomie, Gastgeberkunst und Tischkultur — von Chef à Domicile.",
  "journal.empty": "Neue Geschichten entstehen gerade. Schauen Sie bald wieder vorbei.",
  "journal.related": "Verwandte Geschichten",
  "legal.termsTitle": "Nutzungsbedingungen",
  "legal.privacyTitle": "Datenschutzerklärung",
  "legal.cancelTitle": "Stornierungsrichtlinie",
  "legal.terms1": "Chef à Domicile betreibt einen Marktplatz, der Kunden mit unabhängigen, verifizierten Privatköchen verbindet. Mit der Nutzung von chef-adomicile.com akzeptieren Sie diese Bedingungen. Eine Buchung bildet einen Vertrag zwischen Kunde und Chef, vermittelt durch Chef à Domicile.",
  "legal.terms2": "Preise werden pro Gast angezeigt; der Endbetrag wird bei der Buchung von unserem Service berechnet. Die Zahlung erfolgt über unseren sicheren Partner. Chefs sind unabhängige Fachleute, verantwortlich für die kulinarische Leistung.",
  "legal.terms3": "Alle Inhalte, Marken und Bilder dieser Website gehören Chef à Domicile. Missbrauch der Plattform kann zur Kontosperrung führen.",
  "legal.privacy1": "Wir erheben nur die für Konto und Buchungen nötigen Daten: Identität, Kontaktdaten, Adressen, Ernährungspräferenzen und Verlauf. Wir verkaufen Ihre Daten niemals.",
  "legal.privacy2": "Zahlungsdaten werden ausschließlich von unserem Zahlungspartner verarbeitet; Chef à Domicile speichert niemals Kartennummern.",
  "legal.privacy3": "Sie können jederzeit über die Kontaktseite Zugriff, Berichtigung oder Löschung Ihrer Daten verlangen.",
  "legal.cancel1": "Sie können eine Buchung über Ihr Konto stornieren. Stornierungen mit ausreichendem Vorlauf werden gemäß den bei der Buchung mitgeteilten Bedingungen erstattet.",
  "legal.cancel2": "Späte Stornierungen können Gebühren verursachen, da der Chef Produkte gekauft und den Termin reserviert hat. Geschenkkarten-Zahlungen werden der Karte wieder gutgeschrieben.",
  "legal.cancel3": "Muss ein Chef absagen, bietet unser Concierge einen gleichwertigen verifizierten Chef oder eine volle Erstattung an — nach Ihrer Wahl.",
  "footer.tag": "Außergewöhnliche Küche. Bei Ihnen Zuhause.",
  "footer.explore": "Entdecken",
  "footer.company": "Das Haus",
  "footer.legal": "Rechtliches",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",
  "seo.homeTitle": "Chef à Domicile — Privatkoch Zuhause | Luxus Private Dining",
  "seo.homeDesc": "Buchen Sie einen verifizierten Privatkoch für ein außergewöhnliches Dinner zuhause. Luxus Private Dining in Paris und darüber hinaus — maßgeschneiderte Menüs, Events, Firmen-Erlebnisse.",
};
export default de;
